import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToContact = () => {
    if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', 'ads_conversion_Contact_Us_1', { 'event_timeout': 2000 });
    }
    setIsMobileMenuOpen(false);
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/dc9fac24fb94f27d5caab4f8d511ee93/e75238be69d7d493f2e8bb082a5394f9.png" 
              alt="ADHD Testing Logo" 
              className="h-9 w-9 object-contain"
            />
            <span className={`text-base font-bold transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>ADHD Testing <span className={`font-normal text-sm ${isScrolled ? 'text-gray-500' : 'text-white/70'}`}>by AltaLumé</span></span>
          </div>

          <div className="hidden lg:flex items-center gap-1">
            {[
              { label: 'Home', id: 'home' },
              { label: 'Who Should Test', id: 'who-should-test' },
              { label: 'How It Works', id: 'how-it-works' },
              { label: 'Benefits', id: 'benefits' },
              { label: 'Pricing', id: 'pricing' },
              { label: 'FAQs', id: 'faqs' },
            ].map(({ label, id }) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                className={`px-3 py-2 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  isScrolled ? 'text-gray-600 hover:text-violet-600 hover:bg-violet-50' : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {label}
              </button>
            ))}
            <div className={`w-px h-4 mx-1 ${isScrolled ? 'bg-gray-200' : 'bg-white/30'}`}></div>
            <a
              href="https://www.therapyportal.com/p/altalume/"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-3 py-2 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-600 hover:text-violet-600 hover:bg-violet-50' : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}>
              Client Portal
            </a>
            <button
              onClick={scrollToContact}
              className="ml-2 bg-violet-600 text-white px-5 py-2 rounded-full text-xs font-semibold hover:bg-violet-700 transition-colors whitespace-nowrap cursor-pointer">
              Get Started
            </button>
          </div>

          <button 
            className={`lg:hidden ${isScrolled ? 'text-gray-900' : 'text-white'}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col gap-1 p-3">
              {[
                { label: 'Home', id: 'home' },
                { label: 'Who Should Get Tested', id: 'who-should-test' },
                { label: 'How It Works', id: 'how-it-works' },
                { label: 'Benefits', id: 'benefits' },
                { label: 'Pricing', id: 'pricing' },
                { label: 'FAQs', id: 'faqs' },
              ].map(({ label, id }) => (
                <button
                  key={id}
                  onClick={() => scrollToSection(id)}
                  className="text-left text-sm font-medium text-gray-700 hover:text-violet-600 hover:bg-violet-50 px-3 py-2 rounded-md whitespace-nowrap"
                >
                  {label}
                </button>
              ))}
              <a
                href="https://www.therapyportal.com/p/altalume/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-left text-sm font-medium text-gray-700 hover:text-violet-600 hover:bg-violet-50 px-3 py-2 rounded-md whitespace-nowrap block">
                Client Portal
              </a>
              <button
                onClick={scrollToContact}
                className="bg-violet-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-violet-700 transition-colors mt-2 whitespace-nowrap text-center cursor-pointer">
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
